import { useContext, useEffect, useState, useMemo } from 'react'
import { IntakeContext } from '../context/IntakeContext'
import { useFormDebounce } from 'hooks/useFormDebounce'

import { Box, Button, Grid } from '@mui/material'
import Typography from '@mui/material/Typography'

import google from 'assets/images/logos/google_meets.png'
import teams from 'assets/images/logos/ms_teams.png'
import zoom from 'assets/images/logos/zoom.png'
import meeting from 'assets/images/icons/meeting-background.svg'

import { callZapier } from 'utils/zapier/callZapier'

const WebinarSignup = ({
  closeModal = () => console.log('Register'),
  isOnPageForm = false,
}) => {
  // console.log('isAdmin', isAdmin)
  const { intakeState, updateIntakeStateAtKey } = useContext(IntakeContext)
  const { updateIntakeStateAndSubmit } = useFormDebounce()
  const [registered, setRegistered] = useState(false)

  const registerForWebinar = () => {
    const webinarSignup = {
      firstName: intakeState?.firstName || 'No First Name',
      lastName: intakeState?.lastName || 'No Last Name',
      email: intakeState?.email || 'No Email',
      phone: intakeState?.phone || 'No Phone',
    }
    callZapier({
      user: intakeState,
      hookUrl: 'https://hooks.zapier.com/hooks/catch/15607509/usf3rbi/',
      payload: {
        webinarSignup: webinarSignup,
      },
      notificationMessage: `You have successfully registered for the webinar`,
      sendNotification: true,
    })
    setRegistered(true)
    updateIntakeStateAndSubmit(() => {
      return updateIntakeStateAtKey({ webinarRegistered: true })
    })()
    // closeModal()
  }

  return (
    <Grid sx={{ textAlign: 'left' }} px={2} py={2}>
      {!registered ? (
        <Box textAlign="center" mt={4}>
          <Typography variant="h5" mb={2}>
            RMDs & Roth Conversion - A Critical Retirement Planning Strategy
          </Typography>
          <Typography variant="body1" mb={2}>
            November 25th 2025 @ 7:00 PM EST
          </Typography>
          <Box mb={4}>
            <Button variant="parcoRounded" onClick={registerForWebinar}>
              Sign Up for the Webinar
            </Button>
          </Box>
        </Box>
      ) : (
        <>
          <Box textAlign="center" mt={4}>
            <Typography variant="h5" mb={2}>
              🎉 Webinar Registration Confirmed!
            </Typography>
            <Typography variant="body1">
              RMDs & Roth Conversion - A Critical Retirement Planning Strategy
            </Typography>
            <Typography variant="body1" mb={2}>
              November 25th 2025 @ 7:00 PM EST
            </Typography>
            <Typography variant="body1" mb={2}>
              You will receive a confirmation email with a link to join the
              webinar.
            </Typography>
            {/* <Typography variant="body1" mb={2}>
                You can also simply click the button here on the 25th
              </Typography> */}
            <Box mb={4}>
              <a
                href="https://us06web.zoom.us/webinar/register/WN_0KaaM3GYQp-CJ_iDVBoBLg"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none' }}
              >
                <Button variant="parcoRounded">Join the Webinar</Button>
              </a>
            </Box>
          </Box>
        </>
      )}
    </Grid>
  )
}

export default WebinarSignup
